// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__38GEX","item":"PaymentsMobile_item___sZPF","label":"PaymentsMobile_label__2zZZ4","amount":"PaymentsMobile_amount__3_jos"};